import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Divider, Typography } from '@mui/material';
import CheckBoxRoundedIcon from '@mui/icons-material/CheckBoxRounded';
import IndividualProgressIndicator from 'feature/loading-management/create-new-common/IndividualProgressIndicator';
import { useAddTrailerToLocationMutation } from '../../trailerStatusEndpoints';

const trailerProgressStyles = {
  alignItems: 'center',
  borderBottom: `solid 1px`,
  borderBottomColor: 'graphic.light',
  display: 'grid',
  gridAutoColumns: 'min-content 262px min-content',
  gridAutoFlow: 'column',
  gridGap: 2,
  p: (2, 3),
};
const trailerTitleStyles = {
  maxWidth: '260px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

const SubmittedTrailer = ({ updateHandler, locationId, trailerId }) => {
  const [submitTrailer, { isError, isSuccess }] = useAddTrailerToLocationMutation();
  const [vaporTightnessCode, setVaporTightnessCode] = useState('');

  useEffect(() => {
    const parts = trailerId.split('~');
    setVaporTightnessCode(parts[1]);
    submitTrailer({ locationId, trailerId })
      .unwrap()
      .then(() => {
        updateHandler();
      })
      .catch(err => {
        updateHandler({ err, error: true });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trailerId]);

  return (
    <>
      <Box sx={trailerProgressStyles}>
        <CheckBoxRoundedIcon sx={{ color: 'graphic.main', mr: 1 }} />
        <Typography color="textPrimary" sx={trailerTitleStyles} variant="body1">
          {vaporTightnessCode}
        </Typography>
        <IndividualProgressIndicator
          error={isError ? 'error' : ''}
          isSuccessful={isSuccess ?? false}
        />
      </Box>
      <Divider />
    </>
  );
};

SubmittedTrailer.propTypes = {
  locationId: PropTypes.number.isRequired,
  trailerId: PropTypes.string.isRequired,
  updateHandler: PropTypes.func.isRequired,
};

export default SubmittedTrailer;
